import React from "react";

const Statistique = () => {
  return <div>Statistique</div>;
};

export default Statistique;
